import React from "react";
import EAButton from "../shared/Buttons/EAButton";
import EATextField from "../shared/TextField/EATextField";
import { nipValidator, zipCodeValidator } from "../../../utils/formsValidation";

interface IProps {
  register: any;
  errors: any;
}

const FormPart1: React.FC<IProps> = ({ register, errors }: IProps) => {
  return (
    <>
      <EATextField
        name="nip"
        type="text"
        label="NIP firmy"
        fullWidth
        register={register("nip", { ...nipValidator(true, true) })}
        error={!!errors.nip}
        helperText={errors.nip?.message as string}
      />
      <EATextField
        name="fullName"
        type="text"
        label="Pełna nazwa firmy zgodna z KRS lub CEIDG"
        fullWidth
        register={register("fullName", { required: "To pole jest wymagane" })}
        error={!!errors.fullName}
        helperText={errors.fullName?.message as string}
      />
      <EATextField
        name="street"
        type="text"
        label="Ulica"
        fullWidth
        register={register("street", { required: "To pole jest wymagane" })}
        error={!!errors.street}
        helperText={errors.street?.message as string}
      />
      <div className="b2b-register-two-input">
        <EATextField
          name="houseNumber"
          type="text"
          label="Nr domu"
          fullWidth
          register={register("houseNumber", { required: "To pole jest wymagane" })}
          error={!!errors.houseNumber}
          helperText={errors.houseNumber?.message as string}
        />
        <EATextField
          name="flatNumber"
          type="text"
          label="Nr lokalu"
          fullWidth
          register={register("flatNumber")}
          error={!!errors.flatNumber}
          helperText={errors.flatNumber?.message as string}
        />
      </div>
      <div className="b2b-register-two-input">
        <EATextField
          name="city"
          type="text"
          label="Miasto"
          fullWidth
          register={register("city", { required: "To pole jest wymagane" })}
          error={!!errors.city}
          helperText={errors.city?.message as string}
        />
        <EATextField
          name="zipCode"
          type="text"
          label="Kod pocztowy"
          fullWidth
          register={register("zipCode", { ...zipCodeValidator(true) })}
          error={!!errors.zipCode}
          helperText={errors.zipCode?.message as string}
        />
      </div>
      <div className="b2b-register-next">
        <EAButton title="Dalej" inputType="submit" />
      </div>
    </>
  );
};

export default FormPart1;
